__turbopack_context__.v({
  "glyph": "PigeonLogo-module-scss-module__kup-eG__glyph",
  "header": "PigeonLogo-module-scss-module__kup-eG__header",
  "hero": "PigeonLogo-module-scss-module__kup-eG__hero",
  "root": "PigeonLogo-module-scss-module__kup-eG__root",
});
